import apiConfig from "constants/apiConfig";
import { CollaborationChatRoom } from "types/chat";
import axiosClient from "utils/axiosClient";

export const getBackendTokenForFirebase = async (hubId: string) : Promise<string> => {
    try {
        const response = await axiosClient.post(apiConfig.CREATE_FIREBASE_TOKEN.url.replace('<hubId>', hubId));
        return response.data.token;
    } catch (error) {
        console.error("Failed to fetch firebase custom token", error);
        throw error;
    }
}

export const getCollabChatRoom = async (
    hubId: string,
    campaignId: string,
    collaborationId: string
): Promise<CollaborationChatRoom> => {
    const response = await axiosClient.post(
        apiConfig.COLLAB_CHAT_ROOM.url
            .replace('<hubId>', hubId)
            .replace('<campaignId>', campaignId)
            .replace('<collaborationId>', collaborationId)
    )
    return response.data;
}